import { render, staticRenderFns } from "./GridDesktop.html?vue&type=template&id=a9647682&scoped=true&"
import script from "./GridDesktop.js?vue&type=script&lang=js&"
export * from "./GridDesktop.js?vue&type=script&lang=js&"
import style0 from "./GridDesktop.scss?vue&type=style&index=0&id=a9647682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9647682",
  null
  
)

export default component.exports